import styled, { css } from "styled-components";
import { isTablet, isMobile, isDesktop } from "react-device-detect";
import { handleOrientationChange } from "common/src/helpers/isPortrait";
// ABC ICONS
import { ReactComponent as ProfileABC } from "./../../../abc/src/data/icon-component/profile_icons_profile.svg";
import { ReactComponent as BonusABC } from "./../../../abc/src/data/icon-component/profile_icons_bonuses.svg";
import { ReactComponent as CashbackABC } from "./../../../abc/src/data/icon-component/profile_icons_cashback.svg";
import { ReactComponent as NewPasswordABC } from "./../../../abc/src/data/icon-component/profile_icons_password.svg";
import { ReactComponent as TransactionsABC } from "./../../../abc/src/data/icon-component/profile_icons_transactions.svg";
import { ReactComponent as HisoryABC } from "./../../../abc/src/data/icon-component/history.svg";
import { ReactComponent as PromotionABC } from "./../../../abc/src/data/icon-component/profile_icons_newspromos.svg";
import { ReactComponent as LimitsABC } from "./../../../abc/src/data/icon-component/limits.svg";
import { ReactComponent as VerificationABC } from "./../../../abc/src/data/icon-component/profile_icons_verify.svg";
import { ReactComponent as TournamentsABC } from "./../../../abc/src/data/icon-component/icon-trophy_trophy.svg";

// PUB ICONS
import { ReactComponent as ProfilePUB } from "./../../../pub/src/data/icon-component/myprofile.svg";
import { ReactComponent as CashbackPUB } from "./../../../pub/src/data/icon-component/profile_icons_cashback.svg";
import { ReactComponent as BonusPUB } from "./../../../pub/src/data/icon-component/profile_icons_bonuses.svg";
import { ReactComponent as NewPasswordPUB } from "./../../../pub/src/data/icon-component/profile_icons_password.svg";
import { ReactComponent as TransactionsPUB } from "./../../../pub/src/data/icon-component/profile_icons_transactions.svg";
import { ReactComponent as HisoryPUB } from "./../../../pub/src/data/icon-component/history.svg";
import { ReactComponent as PromotionsPUB } from "./../../../pub/src/data/icon-component/promotion-pub.svg";
import { ReactComponent as LimitsPUB } from "./../../../pub/src/data/icon-component/limits.svg";
import { ReactComponent as VerificationPUB } from "./../../../pub/src/data/icon-component/profile_icons_verify.svg";
import { ReactComponent as TournamentsPUB } from "./../../../pub/src/data/icon-component/icon-trophy_trophy.svg";

const orientation = () => {
  if (isTablet) {
    window.addEventListener("orientationchange", handleOrientationChange);
    return () =>
      window.removeEventListener("orientationchange", handleOrientationChange);
  }
};

const profilePubIconStyles = css`
  width: 71px;
  margin: auto;

  circle {
    fill: var(--profilePubIconCircleFill);
    opacity: var(--profilePubIconCircleOpacity);
    fill-opacity: var(--profilePubIconCircleFillOpacity);
    stroke: var(--profilePubIconCircleStroke);
  }

  #mask-fill-icon {
    fill: var(--profilePubIconMaskFill);
  }
`;

const profilePubIconCashbackStyles = css`
  ${profilePubIconStyles}
  #mask-fill-icon {
    fill: var(--profilePubIconMaskFillCashback);
  }
`;

const profileAbcIconSt0Fill = css`
  .st0 {
    fill: ${({ accountroute }) =>
      accountroute
        ? "#fff"
        : isMobile
          ? "var(--profileAbcIconSt0FillMobile)"
          : "var(--profileAbcIconSt0FillDesktop)"};
  }
`;

// Syled Components
export const StyledGamesHeader = styled.div`
  position: relative;
  height: ${({ account, support }) => {
    if (account) {
      if (isTablet && orientation()) {
        return "var(--styledGamesHeaderHeightAccountTabletLandscape)";
      }
      return "var(--styledGamesHeaderHeightAccount)";
    }
    if (support) {
      return "var(--styledGamesHeaderHeightSupport)";
    }
    return "var(--styledGamesHeaderHeight)";
  }};
  min-height: ${({ account }) =>
    !account && !isMobile && "var(--styledGamesHeaderMinHeight)"};
  background-color: var(--styledGamesHeaderBgColor);
  background-image: ${({ account }) =>
    account
      ? "var(--styledGamesHeaderBgImageAccount)"
      : "var(--styledGamesHeaderBgImage)"};
  background-position: ${({ account }) =>
    account ? "bottom center" : "var(--styledGamesHeaderBgPosition)"};
  background-size: ${({ account, support }) => {
    if (account) return "var(--styledGamesHeaderBgSizeAccount)";
    if (support) return "var(--styledGamesHeaderBgSizeSupport)";
    return isMobile
      ? "var(--styledGamesHeaderBgSizeMobile)"
      : "var(--styledGamesHeaderBgSize)";
  }};
  background-repeat: no-repeat, no-repeat;

  @media screen and (max-width: 767px) {
    height: ${({ account, support, gameCategoryStyleMobile, accountRoute }) => {
      if (account) {
        return "var(--styledGamesHeaderHeightMobileAccount)";
      }
      if (support) {
        return "var(--styledGamesHeaderHeightMobileSupport)";
      }
      if (gameCategoryStyleMobile) {
        return "var(--styledGamesHeaderHeightMobileCategory)";
      }
      if (isMobile && accountRoute) {
        return "var(--styledGamesHeaderHeightMobileRoute)";
      }
      if (isMobile) {
        return "var(--styledGamesHeaderHeightMobileDefault)";
      }
      return "var(--styledGamesHeaderHeightMobileCompact)";
    }};
    background-position: ${({ account }) =>
      account ? "bottom center" : "var(--styledGamesHeaderBgPositionMobile)"};
    @media screen and (orientation: landscape) {
      height: ${({
        account,
        support,
        gameCategoryStyleMobile,
        accountRoute,
      }) => {
        if (account) {
          return "var(--styledGamesHeaderHeightMobileLandscapeAccount)";
        }
        if (support) {
          return "var(--styledGamesHeaderHeightMobileLandscapeSupport)";
        }
        if (gameCategoryStyleMobile) {
          return "var(--styledGamesHeaderHeightMobileLandscapeCategory)";
        }
        if (isMobile && accountRoute) {
          return "var(--styledGamesHeaderHeightMobileLandscapeRoute)";
        }
        return "var(--styledGamesHeaderHeightMobileLandscapeDefault)";
      }};
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    height: ${({ account, support, accountRoute }) => {
      if (account) {
        if (!isMobile && !orientation()) {
          return "var(--styledGamesHeaderHeightTabletAccount)";
        }
        if (isTablet && orientation()) {
          return "var(--styledGamesHeaderHeightTabletAccount)";
        }
        return "var(--styledGamesHeaderHeightTabletAccountCompact)";
      }
      if (support) {
        return "var(--styledGamesHeaderHeightTabletSupport)";
      }
      if (isMobile && accountRoute) {
        return "var(--styledGamesHeaderHeightTabletRoute)";
      }
      return "var(--styledGamesHeaderHeightTabletDefault)";
    }};
    background-position: ${({ account }) =>
      account ? "bottom center" : "var(--styledGamesHeaderBgPositionTablet)"};
  }
`;

export const DarkLayer = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const ContentTopWrapper = styled.div`
  a {
    color: ${() =>
      isMobile
        ? "var(--contentTopWrapperLinkColorMobile)"
        : "var(--contentTopWrapperLinkColor)"};
  }
  .btn {
    font-family: var(--contentTopWrapperBtnFontFamily);
    font-weight: var(--contentTopWrapperBtnFontWeight);
    background-color: transparent;
    margin: 0;
  }

  ${(props) => {
    if (props.profileMenu) {
      if (isTablet) {
        return `
          width: 630px;
          margin: 0 auto;
          margin-top: var(--contentTopWrapperTabletMarginTop);
          
          @media screen and (orientation: landscape) {
            @media (min-width: 1025px) and (max-width: 1366px) {
              margin-top: var(--contentTopWrapperTabletLandscapeMarginTop);
            }
            
          }
        `;
      } else {
        // MOBILN VERZIJA MENIJA
        return `
          .active {
            color: var(--contentTopWrapperMobileActiveColor);
          }
          
          a {
            padding: 0.3rem !important;
            font-weight: 600;
            font-size: var(--contentTopWrapperMobileLinkFontSize);
          }

          @media screen and (max-width: 1024px) {
            max-width: ${
              isMobile
                ? "var(--contentTopWrapperMobileMaxWidthMobile)"
                : "var(--contentTopWrapperMobileMaxWidth)"
            };
            height: 100%;
            margin: 0 auto;
            display: var(--contentTopWrapperMobileDisplay);
            flex-wrap: var(--contentTopWrapperMobileFlexWrap);
            justify-content: ${
              isMobile
                ? "var(--contentTopWrapperMobileJustifyMobile)"
                : "var(--contentTopWrapperMobileJustify)"
            };

            @media screen and (orientation: landscape) {
              justify-content: var(--contentTopWrapperMobileLandscapeJustify);
              max-width:  600px;
            }

            a {
              font-size: var(--contentTopWrapperMobileLandscapeLinkFontSize);
            }
          }
        `;
      }
    } else {
      // DESKTOP VERZIJA MENIJA
      if (props.showProfileMenu) {
        return `
        -webkit-box-shadow: 0px 4px 10px -5px var(--headerbg);
        -moz-box-shadow: 0px 4px 10px -5px var(--headerbg);
        box-shadow: 0px 4px 10px -5px var(--headerbg);
        border-bottom-left-radius: var(--contentTopWrapperDesktopMenuBorderRadius);
        border-bottom-right-radius: var(--contentTopWrapperDesktopMenuBorderRadius);
        border: var(--contentTopWrapperDesktopMenuBorder);
        width: 200px;
        position: absolute;
        top: 80px;
        text-align: left;
        z-index: 100;
        background-color: var(--contentTopWrapperDesktopMenuBg);
        padding-bottom: 20px;
  
        a {
          padding: 15px 30px;
          font-size: 13px;
          color: var(--contentTopWrapperDesktopMenuLinkColor);
          width: 100%;
          float: left;
          bottom: 0px;
          text-align: left;
          z-index: 100;
          border-radius: 0;
        }
        a:hover {
          color: var(--contentTopWrapperDesktopMenuLinkHoverColor) !important;
          background-color: var(--contentTopWrapperDesktopMenuLinkHoverBg);
          border-radius: 0;
        }
        `;
      } else {
        return `
          display: none;
        `;
      }
    }
  }}
`;

export const ProfileMenuWrapper = styled.div.attrs((props) => ({
  className: props.serchLogo ? "w-100" : "",
}))`
  top: ${({ gameSearch }) =>
    gameSearch
      ? "var(--profileMenuWrapperTopSearch)"
      : "var(--profileMenuWrapperTop)"};
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  text-align: center;
  max-width: 100%;
  z-index: 3;
  .list-group {
    padding: 0px;
    box-shadow: var(--profileMenuWrapperListGroupBoxShadow);
    text-align: left;
    border-radius: var(--profileMenuWrapperListGroupBorderRadius);
    margin: var(--profileMenuWrapperListGroupMargin);
    border: var(--profileMenuWrapperListGroupBorder);
    margin-top: var(--profileMenuWrapperListGroupMarginTop);
  }
  .list-group-item {
    color: var(--tabletext);
    border: none;
    -webkit-box-shadow: 0px 0px 2px 0px var(--tabletext);
    -moz-box-shadow: 0px 0px 2px 0px var(--tabletext);
    box-shadow: 0px 0px 2px 0px var(--tabletext);
    span {
      position: absolute;
      top: 5px;
      right: 20px;
      font-size: 12px;
      opacity: 0.6;
    }
  }
  @media screen and (max-width: 767px) {
    top: var(--profileMenuWrapperTopMobile);
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    top: var(--profileMenuWrapperTopTablet);
  }
`;

export const AccountHeader = styled.h1`
  text-align: center;
  font-weight: 900;
  text-transform: uppercase;
  color: var(--accountHeaderColor);
  font-size: 1.8rem;
  padding: ${isTablet || isDesktop ? "2rem 0" : "1rem 0 0 0"};
  width: ${isMobile ? "100%" : "1200px"};
  height: ${isTablet && "100px"};
  margin: 0 auto;
  /* background: rgb(244, 244, 244); */
  background: var(--profileHeaderBg);

  @media screen and (max-width: 767px) {
    position: relative;
    /* clear the 100px mobile header on account routes */
    top: 5.5rem;
  }
`;

export const AboutHeader = styled.h1`
  text-align: center;
  font-weight: var(--aboutHeaderFontWeight);
  font-family: var(--aboutHeaderFontFamily);
  text-transform: var(--aboutHeaderTextTransform);
  font-size: ${({ payments }) =>
    payments ? "230px" : isTablet ? "9vw" : "var(--aboutHeaderFontSize)"};
  width: 100vw;
  height: ${() =>
    isMobile ? "var(--aboutHeaderHeightMobile)" : "var(--aboutHeaderHeight)"};
  margin: 0 auto;
  padding-top: ${({ payments }) =>
    payments ? "1rem" : "var(--aboutHeaderPaddingTop)"};
  vertical-align: top;
  text-shadow: var(--accountTextShadow);
  color: ${({ payments }) =>
    payments ? "var(--paymentHeaderColor)" : "var(--aboutHeaderTextColor)"};

  user-select: none;
  overflow: hidden;

  ${(props) => {
    if (props.payments) {
      return `
      mask-image: linear-gradient(0deg, transparent 0px, red 76px);
      -webkit-mask-image: linear-gradient(0deg, transparent 0px, red 76px);
      `;
    }
  }}

  @media (max-width: 320px) {
    padding-top: 9rem;
    font-size: 14vw;
  }

  @media (min-width: 321px) and (max-width: 767px) {
    /* height: 220px; */
    /*     padding-top: 5rem; */
    font-size: ${({ payments }) =>
      payments
        ? "var(--aboutHeaderFontSizeMobilePayments)"
        : "var(--aboutHeaderFontSizeMobile)"};
    overflow: hidden;
    line-height: normal;
    padding-top: 7rem;

    @media screen and (orientation: landscape) {
      padding-top: 2rem;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    /* height: 220px; */
    position: relative;
    font-size: ${isTablet ? "9vw" : "14.5vw"};
    padding-top: ${isTablet ? "8rem" : "7rem"};
    overflow: hidden;
    line-height: 1;
    @media screen and (orientation: landscape) {
      padding-top: ${isTablet && "7rem"};
    }
  }
`;

export const ContentCard = styled.div`
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70px;
  width: ${() =>
    isMobile
      ? "var(--contentCardSizeMobile)"
      : "var(--contentCardSizeDesktop)"};
  height: ${() =>
    isMobile
      ? "var(--contentCardSizeMobile)"
      : "var(--contentCardSizeDesktop)"};
  margin: 0 auto;
  margin-bottom: ${() => (!isMobile ? "var(--contentCardMarginBottom)" : "")};
  flex-direction: column;

  img {
    margin: auto;
  }
  p {
    margin: auto;
    color: #0554b3;
    font-weight: bold;
    font-size: 2.2rem;
  }
  div {
    color: red;
  }
  ${(props) => {
    if (props.profileMenu) {
      if (props.showProfileMenu) {
        return `
          display: flex;
          background-color: ${
            isMobile
              ? "var(--contentCardBgMenuMobile)"
              : "var(--contentCardBgMenu)"
          };
          border-radius: 0.5rem;
          
          `;
      } else {
        return `
            display: flex;
            background-color: var(--contentCardBgActive);
            border-radius: 0.5rem;


          `;
      }
    } else {
      return `
          display: none;
        `;
    }
  }}
`;

export const StyledInnerDescription = styled.div`
  color: #6998e0;
  font-weight: 600;
  font-size: 0.7rem;
`;

// PROFILE ICONS FOR ABC
export const StyledProfileABC = styled(ProfileABC)`
  width: 25px;
  margin: auto;
  ${profileAbcIconSt0Fill}
`;

export const StyledCashbackABC = styled(CashbackABC)`
  width: 25px;
  margin: auto;
  ${profileAbcIconSt0Fill}
`;

export const StyledBonusABC = styled(BonusABC)`
  width: 25px;
  margin: auto;
  ${profileAbcIconSt0Fill}
`;

export const StyledNewPasswordABC = styled(NewPasswordABC)`
  width: 25px;
  margin: auto;
  ${profileAbcIconSt0Fill}
`;

export const StyledTransactionsABC = styled(TransactionsABC)`
  width: 25px;
  margin: auto;
  ${profileAbcIconSt0Fill}
`;

export const StyledHisoryABC = styled(HisoryABC)`
  width: 25px;
  margin: auto;
  ${profileAbcIconSt0Fill}
`;

export const StyledPromotionABC = styled(PromotionABC)`
  width: 25px;
  margin: auto;
  ${profileAbcIconSt0Fill}
`;

export const StyledLimitsABC = styled(LimitsABC)`
  width: 25px;
  margin: auto;
  ${profileAbcIconSt0Fill}
`;

export const StyledVerificationABC = styled(VerificationABC)`
  width: 25px;
  margin: auto;
  ${profileAbcIconSt0Fill}
`;

export const StyledTournamentsABC = styled(TournamentsABC)`
  margin: auto;
  ${profileAbcIconSt0Fill}
`;

// PROFILE ICONS PUB

export const StyledProfilePUB = styled(ProfilePUB)`
  ${profilePubIconStyles}
`;

export const StyledCashbackPUB = styled(CashbackPUB)`
  ${profilePubIconCashbackStyles}
`;

export const StyledBonusPUB = styled(BonusPUB)`
  ${profilePubIconStyles}
`;

export const StyledNewPasswordPUB = styled(NewPasswordPUB)`
  ${profilePubIconStyles}
`;

export const StyledTransactionsPUB = styled(TransactionsPUB)`
  ${profilePubIconStyles}
`;

export const StyledHistoryPUB = styled(HisoryPUB)`
  ${profilePubIconStyles}
`;

export const StyledPromotionsPUB = styled(PromotionsPUB)`
  ${profilePubIconStyles}
`;

export const StyledLimitsPUB = styled(LimitsPUB)`
  ${profilePubIconStyles}
`;

export const StyledVerificationPUB = styled(VerificationPUB)`
  ${profilePubIconStyles}
`;

export const StyledTournamentsPUB = styled(TournamentsPUB)`
  ${profilePubIconStyles}
`;

export const SupportButtonsWrapper = styled.div.attrs({
  className: "d-flex justify-content-around mx-auto my-0",
})`
  padding-top: var(--supportButtonsWrapperPaddingTop);
  a {
    text-decoration: none;
    min-width: 180px;
  }
  width: ${isTablet ? "100%" : "65%"};
  flex-wrap: ${isMobile && "wrap"};
`;

export const SupportDiv = styled.div.attrs({
  className: "text-center ",
})`
  margin: 0.9rem 0;
  &:first-child {
    margin: 1rem 0 0 0;
  }
  div {
    color: #fff;
    font-weight: 700;
  }
  img {
    margin: 0 1rem;
  }

  span {
    @-moz-document url-prefix() {
      margin-top: 0 !important;
    }
    display: inline-flex;
    width: ${isMobile && "180px"};
    justify-content: ${isMobile && "center"};
    transition: all 0.35s ease 0s;
    div {
      text-decoration: none !important;
      font-family: inherit !important;
      color: var(--supportDivSpanColor);
      :hover {
        color: var(--supportDivSpanHoverColor);
      }
      &:first-child {
        @-moz-document url-prefix() {
          padding-bottom: 0;
        }
      }
    }
  }
`;

export const SupportLink = styled.a`
  background-color: ${({ phone }) =>
    phone ? "var(--supportLinkPhoneBgColor)" : "var(--supportLinkBgColor)"};
  border-radius: var(--supportLinkBorderRadius);
  font-size: 1rem;
  border: var(--supportLinkBorder);
  color: ${({ phone }) =>
    phone ? "var(--supportLinkPhoneColor)" : "var(--supportLinkColor)"};
  font-weight: 700 !important;
  padding: var(--supportLinkPadding);
  position: relative;
  top: 10px;

  &:hover {
    color: var(--supportLinkHoverColor);
    border-color: var(--supportLinkHoverBorderColor);
    background-color: ${({ phone }) =>
      phone
        ? "var(--supportLinkPhoneHoverBgColor)"
        : "var(--supportLinkHoverBgColor)"};
  }

  ${(props) => {
    const beforeStyles = `
      font-family: "Material Icons";
      vertical-align: middle;
      font-size: 1rem;
    `;
    if (props.phone) {
      return `
      &:before {
        ${beforeStyles}
        content: var(--supportLinkPhoneBeforeContent);
      }
      `;
    } else if (props.email) {
      return `
      &:before {
        ${beforeStyles}
        content: var(--supportLinkEmailBeforeContent);
      }
      `;
    } else {
      return `
      &:before {
        ${beforeStyles}
        content: var(--supportLinkBeforeContent);
      }
      `;
    }
  }}
`;
